<template>
  <article>
    <TourItem
      class="tour-item--1"
      contentCol="col--lg-7 col--md-10"
      mediaCol="col--lg-5"
      right
    >
      <h1>
        The Song Swap Showdown chooses Campsite.bio as their #1 Bio Link Tool
      </h1>
      <p>Some of the features they love:</p>
      <ul style="margin-bottom: 1em">
        <li>⛺️ The ease of use and clean UI experience</li>
        <li>⛺️ Customization features that are second to none</li>
        <li>⛺️ YouTube and Spotify integrations to grow their audience</li>
        <li>⛺️ Data and analytics that give them insights</li>
        <li>⛺️ Responsive customer service</li>
      </ul>
      <Button
        class="contrast-btn"
        href="https://campsite.bio/referral-TBGVWRT5"
        size="large"
        color="#ffa600"
        >Get Started for Free</Button
      >
      <VText class="tour-btn-text">Get $10 off when you sign up for Pro</VText>

      <div class="tour-item__device-wrapper" slot="media">
        <ScaledDevice class="device" :width="428" :height="868" ref="preview">
          <DeviceIphone>
            <nuxt-img
              src="/campsites/creators/campsite-songswapshowdown.png"
              :sizes="`xs:500px`"
              :quality="85"
              alt="Campsite.bio profile"
            />
          </DeviceIphone>
        </ScaledDevice>
      </div>
    </TourItem>

    <SeenOn />

    <LargeTextSection
      >Get a best in class link in bio by signing up for the Pro plan. Get $10
      off any plan using the code TBGVWRT5 or by clicking any sign-up link on
      this page.</LargeTextSection
    >

    <section class="choicehacking-quote grid grid--container">
      <Rte>
        <img
          src="~/assets/images/landing/review-stars.png"
          alt=" 5/5 stars"
          loading="lazy"
        />
        <blockquote>
          <p>
            We love using Campsite.bio for our show because it's easy to use,
            super customizable, and provides us with data analytics that helps
            in marketing efforts! Also the integration of Apple Podcasts,
            Spotify &amp; YouTube makes accessing all content from one place
            even easier than ever before so we can give our audience everything
            they need right away!
          </p>
          <cite>- Chris Vaglio - co-host of the Song Swap Showdown</cite>
        </blockquote>
      </Rte>
    </section>

    <ConfigSection button-url="https://campsite.bio/referral-TBGVWRT5" />
    <ProfilesSection button-url="https://campsite.bio/referral-TBGVWRT5" />
    <ProSection
      button-text="Become a Pro"
      button-url="https://campsite.bio/referral-TBGVWRT5"
    />
  </article>
</template>

<script>
import {
  Button,
  ScaledDevice,
  DeviceIphone,
  VText,
} from '@campsite-bio/component-lib';

import TourItem from '@/components/tour-item';
import SeenOn from '@/components/seen-on-analytics';
import ConfigSection from '@/components/home/config-section/config-section';
import ProfilesSection from '@/components/home/profiles-section/profiles-section';
import ProSection from '@/components/home/pro-section/pro-section';
import Rte from '@/components/rte';
import { useMediaQuery } from '@vueuse/core';
import { generateMeta } from '~/utils/generate-meta';
import LargeTextSection from '@/components/sections/large-text-section';

export default {
  components: {
    Button,
    SeenOn,
    ConfigSection,
    ProfilesSection,
    ProSection,
    TourItem,
    Rte,
    ScaledDevice,
    DeviceIphone,
    VText,
    LargeTextSection,
  },

  head() {
    return generateMeta({
      title: "The Chris & Amanda Show's #1 link in bio tool - Campsite.bio",
      description:
        'See why Chris and Amanda from The Chris & Amanda Show chose Campsite.bio for their link in bio tool. They love the the ease of use and UI experience and customization features.',
    });
  },

  layout: 'landing',

  setup() {
    const isLargerScreen = useMediaQuery('(min-width: 768px)');

    return {
      isLargerScreen,
    };
  },
};
</script>

<style lang="scss" scoped>
.tour-btn-text.tour-btn-text {
  margin-top: 0.75rem;
  font-size: 0.85rem;
}

.device {
  margin: 0 auto;
  width: 250px;
  z-index: 1;

  @media (min-width: 992px) {
    width: 344px;
  }

  &::v-deep {
    img {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;

      &:first-child {
        z-index: 1;
      }
    }
  }
}

.choicehacking-quote {
  padding-top: 3rem;

  > div {
    font-size: 1.25rem;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }

  img {
    margin-bottom: -1.5rem;
  }

  blockquote {
    background: none;
    border-left: none;
    font-size: 1em;

    @media (min-width: 544px) {
      font-size: 1.25em;
    }

    cite {
      color: var(--g-color-on-bg);
      font-style: normal;
      font-size: 1rem;
      font-weight: 600;
    }
  }
}
</style>
